import { createStyles, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { defaultViewerPanelSize } from "../../pages/ViewerPage/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        box: {
            display: "flex",
            flexFlow: "row nowrap",
            // justifyContent: "space-between",
            alignItems: "center",
            height: `${defaultViewerPanelSize}px`,
            backgroundColor: theme.palette.primary.main,
            padding: theme.spacing(0, 1),
            color: theme.palette.text.secondary,
            zIndex: 99,
            width: "100%",
            fontSize: "0.8rem"
        },
        button: {
            color: theme.palette.text.secondary,
            margin: theme.spacing(0, 0.8),
            padding: theme.spacing(0.5, 0.5),
            lineHeight: "inherit",
            "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.34)",
            },
        },
        active: {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.text.secondary,
            "&:hover": {
                backgroundColor: theme.palette.text.secondary,
            },
        },
        sheetName: {
            flexGrow: 0,
            verticalAlign: "middle",
        },
        versionSwitch: {
            flexGrow: 0
        },
        icons: {
        },
        left: {
            display: "flex",
            flex: 1,
            alignItems: "center",
        },
        right: {
            paddingLeft: "6rem",
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "space-between",
        }
    })
);

export default useStyles;
